import { render, staticRenderFns } from "./QuestionChange.vue?vue&type=template&id=6f1536a6"
import script from "./QuestionChange.vue?vue&type=script&lang=ts"
export * from "./QuestionChange.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports